import {
    SUMMARY_STATISTICS,
    REVENUE_STATISTICS,
    STAFF_REVENUE_YEARLY,
    STAFF_REVENUE_DETAIL,
    STAFF_INCOME_DETAIL,
    GET_ASSISTANTS_SUPPORT_CASES,
    CUSTOMER_VISIT_STATISTICS
} from '@/redux/actions/types';

const INIT_STATE = {
    statistics: [],
    revenue_statistics: {},
    staff_revenue_yearly: [],
    staff_revenue_detail: {
        summary: null,
        detail: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    staff_income_detail: {
        summary: null,
        detail: [],
        pagination: { currentPage: 1, total: 0, perPage: 30 }
    },
    assistants_support_cases: {
        summary: null,
        detail: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    customer_visits: {
        summary: null,
        by_group: [],
        detail: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SUMMARY_STATISTICS: {
            return {
                ...state,
                statistics: action.payload?.data || [],
            }
        }

        case REVENUE_STATISTICS: {
            return {
                ...state,
                revenue_statistics: action.payload?.data || [],
            }
        }

        case STAFF_REVENUE_YEARLY: {
            return {
                ...state,
                staff_revenue_yearly: action.payload?.data || [],
            };
        }

        case STAFF_REVENUE_DETAIL: {
            const summary = action.payload?.data?.summary || null;
            const detail = action.payload?.data?.detail || [];
            const p = action.payload?.data?.pagination || {};

            return {
                ...state,
                staff_revenue_detail: {
                    summary,
                    detail,
                    pagination: {
                        currentPage: Number(p.page) || 1,
                        perPage: Number(p.per_page) || 30,
                        total: Number(p.total) || 0,
                    }
                }
            };
        }

        case STAFF_INCOME_DETAIL: {
            const data = action.payload?.data || {};
            const p = data.pagination || {};
            return {
                ...state,
                staff_income_detail: {
                    summary: data.summary || null,
                    detail: data.detail || [],
                    pagination: { currentPage: Number(p.page) || 1, perPage: Number(p.per_page) || 30, total: Number(p.total) || 0 }
                }
            };
        }

        case GET_ASSISTANTS_SUPPORT_CASES: {
            const summary = action.payload?.data?.summary[0] || null;
            const detail = action.payload?.data?.detail || [];

            return {
                ...state,
                assistants_support_cases: {
                    summary,
                    detail
                }
            };
        }

        case CUSTOMER_VISIT_STATISTICS: {
            const data = action.payload?.data || {};

            const summary = data.summary || null;
            const by_group = data.by_group || [];
            const detail = data.detail || [];
            const p = data.pagination || {};

            return {
                ...state,
                customer_visits: {
                    summary,
                    by_group,
                    detail,
                    pagination: {
                        currentPage: Number(p.page) || 1,
                        perPage: Number(p.per_page) || 30,
                        total: Number(p.total) || 0,
                    }
                }
            };
        }


        default:
            return { ...state };
    }
}
